module.exports = __webpack_public_path__ + "media/images/homes/multiple_locations2x-3cc5750445e1a0d4e002a633db4530b8.png";